import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  TripPlace,
  TripPlaceFilters,
  TripPlaceSort
} from '../../lib/types/models/trip-places/trip-places'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getJourneyTripPlaces<T extends string>(
  input: PaginationRequest<TripPlaceFilters, T, T, TripPlaceSort> = {}
) {
  const url = constructApiUrl(API.tripPlaces.getAll.url, null)
  if (!input.sort) input.sort = { label: 'asc' }
  return restApiClient.url(encodeNestedObject(url, input)).get<PaginationResponse<TripPlace>>()
}
